import type { WorkflowState } from "~/types/api";

export const workflowStatusMap: Record<WorkflowState, string> = {
  WorkInProgress: "Work In Progress",
  Active: "Active",
  Completed: "Completed",
};
